import config from "./Config"

export const trendingBids = [
  {
    id: 1,
    src: `${
      config.BIDNWIN_S3_IMAGE_URL_NEW_UI
    }/trending/homescreen/onePlus7Pro.webp`,
    src2x: `${config.BIDNWIN_S3_IMAGE_URL_NEW_UI}/trending/onePlus7Pro@2x.webp`,
    alt: "One Plus 7 Pro",
    title: "One Plus 7 Pro",
    timeLeft: "03:46:01",
  },
  {
    id: 2,
    src: `${
      config.BIDNWIN_S3_IMAGE_URL_NEW_UI
    }/trending/homescreen/amazon.webp`,
    src2x: `${config.BIDNWIN_S3_IMAGE_URL_NEW_UI}/trending/amazon@2x.webp`,
    alt: "Amazon",
    title: "Amazon",
    timeLeft: "03:46:01",
  },
  {
    id: 3,
    src: `${config.BIDNWIN_S3_IMAGE_URL_NEW_UI}/trending/homescreen/z1x.webp`,
    src2x: `${config.BIDNWIN_S3_IMAGE_URL_NEW_UI}/trending/z1x@2x.webp`,
    alt: "Z1x",
    title: "Z1x",
    timeLeft: "03:46:01",
  },
]

export const dailyBids = [
  {
    id: 1,
    src: `${
      config.BIDNWIN_S3_IMAGE_URL_NEW_UI
    }/trending/homescreen/onePlus7Pro.webp`,
    src2x: `${config.BIDNWIN_S3_IMAGE_URL_NEW_UI}/trending/onePlus7Pro@2x.webp`,
    alt: "One Plus 7 Pro",
    title: "One Plus 7 Pro",
    timeLeft: "03:46:01",
  },
  {
    id: 2,
    src: `${
      config.BIDNWIN_S3_IMAGE_URL_NEW_UI
    }/trending/homescreen/amazon.webp`,
    src2x: `${config.BIDNWIN_S3_IMAGE_URL_NEW_UI}/trending/amazon@2x.webp`,
    alt: "Amazon",
    title: "Amazon",
    timeLeft: "03:46:01",
  },
  {
    id: 3,
    src: `${config.BIDNWIN_S3_IMAGE_URL_NEW_UI}/trending/homescreen/z1x.webp`,
    src2x: `${config.BIDNWIN_S3_IMAGE_URL_NEW_UI}/trending/z1x@2x.webp`,
    alt: "Z1x",
    title: "Z1x",
    timeLeft: "03:46:01",
  },
]

export const weeklyBids = [
  {
    id: 1,
    src: `${
      config.BIDNWIN_S3_IMAGE_URL_NEW_UI
    }/trending/homescreen/onePlus7Pro.webp`,
    src2x: `${config.BIDNWIN_S3_IMAGE_URL_NEW_UI}/trending/onePlus7Pro@2x.webp`,
    alt: "One Plus 7 Pro",
    title: "One Plus 7 Pro",
    timeLeft: "03:46:01",
  },
  {
    id: 2,
    src: `${
      config.BIDNWIN_S3_IMAGE_URL_NEW_UI
    }/trending/homescreen/amazon.webp`,
    src2x: `${config.BIDNWIN_S3_IMAGE_URL_NEW_UI}/trending/amazon@2x.webp`,
    alt: "Amazon",
    title: "Amazon",
    timeLeft: "03:46:01",
  },
  {
    id: 3,
    src: `${config.BIDNWIN_S3_IMAGE_URL_NEW_UI}/trending/homescreen/z1x.webp`,
    src2x: `${config.BIDNWIN_S3_IMAGE_URL_NEW_UI}/trending/z1x@2x.webp`,
    alt: "Z1x",
    title: "Z1x",
    timeLeft: "03:46:01",
  },
]

export const htbImages = [
  {
    id: 1,
    src: `${config.BIDNWIN_S3_IMAGE_URL_NEW_UI}/htb1.png`,
    alt: "How to Bid Step1",
  },
  {
    id: 2,
    src: `${config.BIDNWIN_S3_IMAGE_URL_NEW_UI}/htb2.png`,
    alt: "How to Bid Step2",
  },
  {
    id: 3,
    src: `${config.BIDNWIN_S3_IMAGE_URL_NEW_UI}/htb3.png`,
    alt: "How to Bid Step3",
  },
  {
    id: 4,
    src: `${config.BIDNWIN_S3_IMAGE_URL_NEW_UI}/htb4.png`,
    alt: "How to Bid Step4",
  },
]

export const bidwinStats = [
  { id: 1, title: "Total Users", stats: "100K" },
  { id: 2, title: "Countries", stats: "70" },
  { id: 3, title: "Bids Won", stats: "2K" },
  { id: 4, title: "Prizes Won", stats: "$40K" },
]



// WEBPACK FOOTER //
// ./src/dummyData.js